import Axios from 'axios';
import config from '@/config';
import { auth } from "@/store/modules";

export enum FileType {
  pdf = 'pdf',
  csv = 'csv',
  xlsx = 'xlsx'
}

export interface UrlConfig {
  appUrl?: string;
  apiUrl?: string;
  functionsUrl?: string;
}

export default class LambdaDownloader {
  public urlConfig: UrlConfig;

  constructor(
    private payload: object,
    private lambda: string,
    private filename: string,
    private onIsLoading: (value: boolean) => void = (v) => {},
    urlConfig: UrlConfig = {}
  ) {
    this.urlConfig = Object.assign({
      appUrl: config.appUrl,
      apiUrl: config.apiUrl,
      functionsUrl: config.functionsUrl,
    }, urlConfig as any);
  }

  /**
   * Start remote request to lambda.
   */
  async start() {
    try {
      this.onIsLoading(true);

      const fileResult = await Axios.post<ArrayBuffer>(
        `${this.urlConfig.functionsUrl}/${this.lambda}`,
        {
          urlConfig: this.urlConfig,
          ...this.payload
        },
        {
          responseType: "arraybuffer",
          headers: {
            "Accept": "*",
            AUTH_CENTER: auth.currentCenterId
          }
        }
      );

      const contentType = fileResult.headers['content-type'] || '';
      const fileType = LambdaDownloader.getExtensionFromMime(contentType, 'txt');
      const blob = new Blob([fileResult.data], { type: contentType });
      LambdaDownloader.downloadHack(blob, `${this.filename}.${fileType}`);
    } finally {
      this.onIsLoading(false);
    }
  }

  /**
   *
   * @param {Blob} content
   * @param {string} filename
   */
  public static downloadHack(content: Blob, filename?: string) {
    const url = window.URL.createObjectURL(content);
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;
    a.download = filename || "unknown_file";
    a.click();
    window.URL.revokeObjectURL(url);
  }

  /**
   * Guess potential file extension based on return mime type
   * @param {string} contentType
   * @param {string} def
   * @returns {string}
   */
  public static getExtensionFromMime(contentType: string, def: string = 'txt') {
    const mime = (contentType || '').split(';')[0].trim();
    switch (mime) {
      case 'application/pdf':
        return 'pdf';
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        return 'xlsx';
      case 'text/csv':
        return 'csv';
    }

    return def;
  }

  public static async dataURItoBlob(dataURI: string): Promise<Blob> {
    const base64Response = await fetch(dataURI);
    const blob = await base64Response.blob();
    return blob;
  }
}
